import Vue from 'vue'
import App from './App.vue'
import 'lib-flexible'
import '@/utils/prototype'
import {request} from '@/server/http'
import VueWechatTitle from 'vue-wechat-title'
import {routerBefore} from '@/routerBefore'
import toast from '@/plugin/toast'
import confirm from '@/plugin/confirm'
import loading from '@/plugin/loading'
import Icon from '@/components/Icon'
import HtmlToPdf from '@/plugin/util/HtmlToPdf'

Vue.config.productionTip = false;
Vue.prototype.$a = request;
Vue.use(VueWechatTitle);
Vue.use(toast);
Vue.use(confirm);
Vue.use(loading);
Vue.component('Icon', Icon);
Vue.use(HtmlToPdf);

new Vue({
    router: routerBefore,
    render: h => h(App)
}).$mount('#app');
